<template>
  <list-layout class="list-layout" :pageSize="pageSize" :currentPage="currentPage" :total="total"  @current-change="handleChange" @size-change="handleSizeChange">
    <span slot="title">委托库查询</span>
    <div class="tab" slot="btn_tabs">
      <el-tabs class="tab" :value="typename" @tab-click="btnTabClick">
        <el-tab-pane :disabled="IsLoading" label="委托总库" name="all"></el-tab-pane>
        <el-tab-pane :disabled="IsLoading" label="自己委托库" id="self" name="self"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form slot="search-bar" :inline="true">
      <el-form-item label="物料名称">
        <el-input class="form-input" v-model="Search.Product" @keyup.enter.native="handleSearch" placeholder="请输入物料名称／物料编码／客户物料名称／客户物料编码"></el-input>
      </el-form-item>
      <el-form-item label="区域">
        <el-select class="form-input" clearable filterable v-model="Search.Region" placeholder="请选择或输入区域">
          <el-option v-for="item in Regions" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品牌">
        <el-select class="form-input" clearable filterable  @change="changeBrand" v-model="Search.BrandName" placeholder="请选择或输入品牌">
          <el-option v-for="item in BrandNames" :key="item.Id" :label="item.Name" :value="item.Name">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="机型">
        <el-select v-model="Search.ProductModel" clearable filterable @change="changeModels" placeholder="请选择或输入机型">
          <el-option v-for="item in ProductModels" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模块">
        <el-select v-model="Search.ProductModule" clearable filterable placeholder="请选择或输入模块">
          <el-option v-for="item in ProductModules" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="品项" v-if="typename == 'self'">
        <el-select v-model="Search.ProductCondition" clearable filterable placeholder="请选择或输入品项">
          <el-option v-for="item in ProductConditions" :key="item.Id" :label="item.Name" :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="IsLoading" @click="search()" >查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tab" slot="tabs">
      <el-tabs class="tab" :value="activename" @tab-click="handleTabClick">
        <el-tab-pane label="可租可售" name="rent_sales"></el-tab-pane>
        <el-tab-pane label="只售" name="sales"></el-tab-pane>
        <el-tab-pane label="只租" name="rent"></el-tab-pane>
        <el-tab-pane label="委托到期物料" name="managed" v-if="typename == 'self'"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-loading="IsLoading" element-loading-text="加载中" class="table_area" slot="table_area">
      <div class="order-box" v-if="typename == 'all'">
        <el-button class="add-btn1" @click.native="toPurchase()" v-if="activename == 'rent_sales' || activename == 'sales'">采购询价单
          <span v-if="this.purchasebox.length !== 0 ">{{this.purchasebox.length}}</span>
        </el-button>
        <el-button class="add-btn" @click.native="toLeaseapply()" v-if="activename == 'rent_sales' || activename == 'rent'">租赁申请单
          <span v-if="this.leaseapplybox.length != 0 ">{{this.leaseapplybox.length}}</span>
        </el-button>
      </div>
      <div class="order-box" v-else>
        <el-button class="add-btn1" @click.native="toManagedShip()" v-if="activename != 'managed'">发货通知单
          <span v-if="this.shipbox.length !== 0 ">{{this.shipbox.length}}</span>
        </el-button>
        <el-button class="add-btn" @click.native="toManagedApply()" v-if="activename != 'managed'">调度申请单
          <span v-if="this.managedbox.length !== 0 ">{{this.managedbox.length}}</span>
        </el-button>
        <!-- <el-button class="add-btn" @click.native="contact()" v-if="activename == 'managed'">联系客服寄回</el-button> -->
        <p class="pull-left" v-if="activename == 'managed'">联系客服寄回：0755-82405890</p>
        <el-button class="add-btn" @click.native="toTrustActive()" :disabled="this.batchSelection.length === 0" v-if="activename == 'managed'">激活委托<span v-if="this.activebox.length !== 0 ">{{this.activebox.length}}</span></el-button>
      </div>
      <table v-if="activename != 'managed'">
        <thead>
          <tr>
            <td>物料名称／编码</td>
            <td>客户物料名称／编码</td>
            <td>品项</td>
            <td>品牌</td>
            <td>机型</td>
            <td>模块</td>
            <td>库存数量</td>
            <td>区域</td>
            <td>操作</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tableData">
            <td width="260">
              {{item.ProductName}}<br>物料编码： {{item.ProductCode}}
            </td>
            <td width="240">{{item.CustomerProductName}}<br>物料编码： {{item.CustomerProductCode}}</td>
            <td width="100">
              <el-tag :type="item.ConditionName | ConditionColor" v-if="item.ConditionName != null">{{item.ConditionName}}</el-tag>
              <span v-if='item.ConditionName == null'>-</span>
            </td>
            <td width="100">{{item.ProductBrandName}}</td>
            <td width="200">{{item.ProductModelName}}</td>
            <td width="120">{{item.ProductModuleName}}</td>
            <td width="100">{{item.Quantity}}</td>
            <td width="100">{{item.RegionName}}</td>
            <td width="250" v-if="typename == 'all'">
              <div class="allweare" v-if="activename == 'rent_sales' || activename == 'rent'">
                <el-button type="primary" size="mini" @click.native="addLeaseapply(item)" v-if="ifAddLeaseapply(item) && item.Quantity > 0" style="margin-right:5px;">加入租赁</el-button>
                <el-button type="danger" size="mini" @click.native="cancelLeaseapply(item)" v-else-if="!ifAddLeaseapply(item) || item.Quantity > 0">取消加入租赁</el-button>
              </div>
              <div class="allweare" v-if="activename == 'rent_sales' || activename == 'sales'">
                <el-button type="warning" size="mini" @click.native="addPrice(item)" v-if="ifAddPurchase(item)">加入询价</el-button>
                <el-button type="danger" size="mini" @click.native="cancelPricebtn(item)" v-else>取消加入询价</el-button>
              </div>
            </td>
            <td width="300" v-else>
              <el-button type="primary" size="mini" @click.native="todetail(item)">查看</el-button>
              <el-button type="primary" size="mini" @click.native="addManaged(item)" style="margin-left:0px;" v-if="ifAddManaged(item) && item.Quantity > 0">加入调度</el-button>
              <el-button type="danger" size="mini" @click.native="cancelManaged(item)" style="margin-left:0px;" v-else-if="!ifAddManaged(item) || item.Quantity > 0">取消加入调度</el-button>
              <el-button type="primary" size="mini" @click.native="addInvoice(item)" style="margin-left:0px;" v-if="ifAddInvoice(item) && item.Quantity > 0">加入发货</el-button>
              <el-button type="danger" size="mini" @click.native="cancelInvoice(item)" style="margin-left:0px;" v-else-if="!ifAddInvoice(item) || item.Quantity > 0">取消加入发货</el-button>
            </td>
          </tr>
        </tbody>
      </table>
      <el-form :model="newsend" ref="ruleForm" :rules="rules" v-if="total === 0 && is_checked === 0">
          <table class="newbox" >
            <!-- <thead>
              <tr>
                <td width="260">物料名称</td>
                <td width="120">物料编码</td>
                <td width="100">品牌</td>
                <td width="100">机型</td>
                <td width="100">模块</td>
                <td width="80">库存数量</td>
                <td width="200">操作</td>
              </tr>
            </thead> -->
            <tbody>
              <tr>
                <td colspan="7">
                  <p class="canadd">抱歉，没有找到您要的产品</p>
                </td>
              </tr>
<!--               <tr>
                <td>
                  <el-form-item prop="ProductName">
                    <el-input class="form-input" v-model="newsend.ProductName" placeholder="请输入物料名称"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="ProductCode">
                    <el-input class="form-input" v-model="newsend.ProductCode" placeholder="请输入物料编码"></el-input>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="ProductBrandId">
                    <el-select v-model="newsend.ProductBrandId" filterable placeholder="请选择品牌">
                      <el-option v-for="item in BrandNames" :key="item.Id" :label="item.Name" :value="item.Id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="ProductModelId">
                    <el-select v-model="newsend.ProductModelId" filterable placeholder="请选择机型">
                      <el-option v-for="item in ProductModels" :key="item.Id" :label="item.Name" :value="item.Id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="ProductModuleId">
                    <el-select v-model="newsend.ProductModuleId" filterable placeholder="请选择模块">
                      <el-option v-for="item in ProductModules" :key="item.Id" :label="item.Name" :value="item.Id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>
                  <el-form-item prop="Quantity">
                    <el-input-number placeholder="数量" :min=1 v-model="newsend.Quantity"></el-input-number>
                  </el-form-item>
                </td>
                <td v-if="typename == 'all'">
                    <div class="allweare" v-if="activename == 'rent_sales' || activename == 'sales'">
                      <el-button type="primary" @click.native="addnewPrice(newsend)" v-if="ifAddPurchase(newsend)" style="margin-left:0px;">加入询价</el-button>
                      <el-button type="danger" @click.native="cancelPricebtn(newsend)" v-else style="margin-left:0px;">取消加入询价</el-button>
                    </div>
                </td>
              </tr> -->
            </tbody>
          </table>
        </el-form>      
        <el-table :data="tableData" ref="multipleTable" tooltip-effect="dark" class="timedata" @selection-change="handleSelectionChange" v-if="activename == 'managed'">
        <el-table-column type="selection" width="60">
        </el-table-column>
        <el-table-column prop="ProductCode" label="批次号" width="100">
        </el-table-column>
        <el-table-column label="物料名称" width="220">
          <template scope="prop">
            <el-col>{{prop.row.ProductName}}</el-col>
            <el-col>物料编码：{{prop.row.ProductCode}}</el-col>
          </template>
        </el-table-column>
        <el-table-column label="品项" width="100">
          <template scope="prop">
            <el-tag :type="prop.row.ConditionName | ConditionColor" v-if="prop.row.ConditionName != null">{{prop.row.ConditionName}}</el-tag>
            <span v-if='prop.row.ConditionName == null'>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="ProductBrandName" label="品牌" width="100">
        </el-table-column>
        <el-table-column prop="ProductModelName" label="机型" width="100">
        </el-table-column>
        <el-table-column prop="ProductModuleName" label="模块" width="100">
        </el-table-column>
        <el-table-column prop="Quantity" label="数量" width="100">
        </el-table-column>
        <el-table-column prop="RegionName" label="区域" width="100">
        </el-table-column>
        <el-table-column prop="EntrustDay" label="委托时长" width="140">
        </el-table-column>
        <el-table-column prop="RemainingTime" label="到期时间" width="140">
        </el-table-column>
        <el-table-column label="操作" width="170">
          <template scope="prop">
            <el-button type="text" @click.native="todetailManaged(prop)">查看</el-button>
            <!-- <el-button type="text" @click.native="addActive(prop)" v-if="ifAddActive(prop)">加入激活</el-button>
                <el-button type="text" @click.native="cancelActive(prop)" v-else>取消加入激活</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="委托激活" size="small" class="pop-box" v-model="managedActiveFormVisible">
        <p>你正在对
          <span style="color:#20a0ff;">{{this.batchSelection.length}}</span> 个批次进行延长委托的操作，请选择希望延长的时长：</p>
        <el-select class="form-input" filterable v-model="managedTime" placeholder="请选择委托时长">
          <el-option v-for="item in managedTimes" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="sureActive()">提交并等待客服联系</el-button>
        </div>
      </el-dialog>
    </div>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/pages/Repair/ListLayout'
import o from '@/odata'
export default {
  data() {
    return {
      // 客户自填物料品项默认为原装全新
      newsend: {
        ConditionId: 1,
        ConditionName: '',
        ProductName: null,
        ProductCode: '',
        ProductBrandName: '',
        ProductModelName: '',
        ProductModuleName: '',
        EntrustDay: '',
        RemainingTime: '',
        RegionName: '',
        Quantity: null,
      },
      rules: {
        ProductName: [{required: true, message: '请输入物料名称', trigger: 'blur'}],
      },
      Search: {
        Product: null,
        Region: null,
        BrandName: null,
        ProductModel: null,
        ProductModule: null,
        ProductCondition: null,
      },
      IsLoading: false,
      managedTime: null,
      if_managed: false,
      managedActiveFormVisible: false,
      leaseapplybox: [],
      purchasebox: [],
      shipbox: [],
      managedTimes: [
        { label: '30天', value: '30' },
        { label: '60天', value: '60' },
        { label: '90天', value: '90' },
        { label: '120天', value: '120' },
        { label: '180天', value: '180' },
        { label: '210天', value: '210' },
      ],
      managedTimeData: [],
      managedbox: [],
      activebox: [],
      Regions: [],
      BrandNames: [],
      ProductModels: [],
      ProductModules: [],
      ProductConditions: [],
      OriginalOrderTypes: [
        { label: '入库单', value: 'InStockPicking' },
        { label: '租赁单', value: 'RentalOrder' },
        { label: '发货单', value: 'OutStockPicking' },
        { label: '内部调拨单', value: 'InternalStockPicking' },
        { label: '物流单', value: 'DeliveryOrder' },
        { label: '备用件退货单', value: 'DeliveryBackupReturn' },
        { label: '质检单', value: 'QcOrder' },
        { label: '租赁退货单', value: 'RentalReturnOrder' },
        { label: '租赁换货单', value: 'RentalExchangeOrder' },
        { label: '租赁维修单', value: 'RentalRepairOrder' },
        { label: '盘点单', value: 'InventoryOrder' },
        { label: '维修订单', value: 'RepairOrder' },
        { label: '维修单', value: 'RepairWorkOrder' },
        { label: '委外维修单', value: 'ExternalRepairWorkOrder' },
      ],
      activename: 'rent_sales',
      typename: 'all',
      warehouseDate: '',
      newboxshow: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      is_checked: 1,
      RepairTypes: [
        { label: '租赁维修', value: 'rental' },
        { label: '委托维修', value: 'delegated' },
        { label: '代管维修', value: 'managed' },
        { label: '拆件维修', value: 'parts' },
      ],
      tableData: [],
      batchSelection: [],
      sendform: [],
      orderUrl: '',
      sorts: ['日立', 'NCR', '迪堡', 'WINCOR', '运通', '御银', '富士通', '怡化', 'OKI', '东信', '恒银', '晓星', '新达通', '科堡', 'LG', 'NMD', '其他品牌'],  // 品牌用来排序的数组
    }
  },
  methods: {
    // 当选择机型后后根据机型对模块进行三级联动
    changeModels: function(modelId) {
      // TODO
    },
    // 当选择品牌后根据品牌名对机型进行二级联动
    changeBrand: function(brandName) {
      // 如果有选中品牌则给初始化机型方法传入品牌名字参数，没有则重新初始化
      if (brandName) {
        this.initProductModel(brandName)
      } else {
        this.initProductModel()
      }
    },
    handleSelectionChange: function(selection) {
      this.batchSelection = selection
    },
    sureActive: function() {
      this.sendform = []
      this.IsLoading = true
      for (var a = 0; a < this.batchSelection.length; a++) {
        this.sendform.push(this.batchSelection[a].id)
      }
      const RepairOrder = o('DelegationActivationLot/Services.Activate')
      const form = {
        PeriodInDays: this.managedTime,
        LotIds: this.sendform,
      }
      RepairOrder.post(form).save().then((data) => {
        this.$message({
          message: '提交成功',
          type: 'success',
        })
        this.managedActiveFormVisible = false
        this.handleSearch()
        this.IsLoading = false
      }).catch(() => {
        this.IsLoading = false
        this.$message({
          message: '提交失败, 不能为空',
          type: 'info',
        })
      })
    },
    toTrustActive: function() {
      this.managedActiveFormVisible = true
    },
    addActive: function(prop) {
      this.activebox.push(prop.row)
    },
    cancelActive: function(prop) {
      let indexs = ''
      for (var a = 0; a < this.activebox.length; a++) {
        if ((this.activebox[a].ConditionId === prop.row.ConditionId) && (this.activebox[a].ProductId === prop.row.ProductId)) {
          indexs = a
        }
      }
      this.activebox.splice(indexs, 1)
    },
    ifAddActive: function(prop) {
      let ifVal = true
      if (this.activebox.length > 0) {
        for (var a = 0; a < this.activebox.length; a++) {
          if ((this.activebox[a].ConditionId === prop.row.ConditionId) && (this.activebox[a].ProductId === prop.row.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    addManaged: function(item) {
      this.managedbox.push(item)
      window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
    },
    cancelManaged: function(item) {
      let indexs = ''
      for (var a = 0; a < this.managedbox.length; a++) {
        if ((this.managedbox[a].ConditionId === item.ConditionId) && (this.managedbox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.managedbox.splice(indexs, 1)
      window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
    },
    ifAddManaged: function(item) {
      let ifVal = true
      if (this.managedbox.length > 0) {
        for (var a = 0; a < this.managedbox.length; a++) {
          if ((this.managedbox[a].ConditionId === item.ConditionId) && (this.managedbox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    addLeaseapply: function(item) {
      this.leaseapplybox.push(item)
      window.localStorage.setItem('leaseapplybox', JSON.stringify(this.leaseapplybox))
    },
    cancelLeaseapply: function(item) {
      let indexs = ''
      for (var a = 0; a < this.leaseapplybox.length; a++) {
        if ((this.leaseapplybox[a].ConditionId === item.ConditionId) && (this.leaseapplybox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.leaseapplybox.splice(indexs, 1)
      window.localStorage.setItem('leaseapplybox', JSON.stringify(this.leaseapplybox))
    },
    ifAddLeaseapply: function(item) {
      let ifVal = true
      if (this.leaseapplybox.length > 0) {
        for (var a = 0; a < this.leaseapplybox.length; a++) {
          if ((this.leaseapplybox[a].ConditionId === item.ConditionId) && (this.leaseapplybox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    addInvoice: function(item) {
      item.type = 'delegate'
      this.shipbox.push(item)
      window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
    },
    cancelInvoice: function(item) {
      let indexs = ''
      for (var a = 0; a < this.shipbox.length; a++) {
        if ((this.shipbox[a].ConditionId === item.ConditionId) && (this.shipbox[a].ProductId === item.ProductId)) {
          indexs = a
        }
      }
      this.shipbox.splice(indexs, 1)
      window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
    },
    ifAddInvoice: function(item) {
      let ifVal = true
      if (this.shipbox.length > 0) {
        for (var a = 0; a < this.shipbox.length; a++) {
          if ((this.shipbox[a].ConditionId === item.ConditionId) && (this.shipbox[a].ProductId === item.ProductId)) {
            ifVal = false
          }
        }
      }
      return ifVal
    },
    // 加入询价
    addPrice: function(item) {
      this.purchasebox.push(item)
      window.localStorage.setItem('purchasebox', JSON.stringify(this.purchasebox))
    },
    /* 增加客户自定义询价物料 表单：this.newSend */
    addnewPrice: function() {
      this.$refs['ruleForm'].validate((valid) => {
        // 验证通过
        if (valid) {
          // 获取品项名称
          this.newsend.ConditionName = this.ProductConditions.find((_) => _.Id === this.newsend.ConditionId).Name
          // 添加到缓存中
          this.purchasebox.push(this.newsend)
          window.localStorage.setItem('purchasebox', JSON.stringify(this.purchasebox))
          this.$message({
            message: '添加询价成功',
            type: 'success',
          })
          // 清空
          this.newsend = {
            ConditionId: 1,
            ConditionName: '',
            ProductName: null,
            ProductCode: '',
            ProductBrandName: '',
            ProductModelName: '',
            ProductModuleName: '',
            EntrustDay: '',
            RemainingTime: '',
            RegionName: '',
            Quantity: 1,
          }
        }
      })
    },
    cancelPricebtn: function(item) {
      let valbb = ''
      for (var a = 0; a < this.purchasebox.length; a++) {
        if ((this.purchasebox[a].ConditionId === item.ConditionId) && (this.purchasebox[a].ProductId === item.ProductId)) {
          valbb = a
        }
      }
      this.purchasebox.splice(valbb, 1)
      window.localStorage.setItem('purchasebox', JSON.stringify(this.purchasebox))
    },
    ifAddPurchase: function(item) {
      let ifVal = true
      if (this.purchasebox.length > 0) {
        for (var a = 0; a < this.purchasebox.length; a++) {
          if (item.ConditionId === null || item.ProductId === null) {
            ifVal = true
          } else {
            if ((this.purchasebox[a].ConditionId === item.ConditionId) && (this.purchasebox[a].ProductId === item.ProductId)) {
              ifVal = false
            }
          }
        }
      }
      return ifVal
    },
    toPurchase: function() {
      if (this.purchasebox.length > 0) {
        this.$router.push('/purchase')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    toManagedApply: function() {
      window.localStorage.setItem('managedApplyFlag', 'trustListPage')
      if (this.managedbox.length > 0) {
        this.$router.push('/managed_apply')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    toLeaseapply: function() {
      if (this.leaseapplybox.length > 0) {
        this.$router.push('/lease_apply')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    toManagedShip: function() {
      window.localStorage.setItem('newshipFlag', 'trustListPage')
      if (this.shipbox.length > 0) {
        this.$router.push('/newship')
      } else {
        this.$message({
          message: '请添加物料！',
          type: 'info',
        })
      }
    },
    todetail: function(item) {
      this.$router.push('/trust/' + item.ConditionId + '&' + item.ProductId + '&' + this.activename)
    },
    todetailManaged: function(prop) {
      this.$router.push('/trust/' + prop.row.ConditionId + '&' + prop.row.ProductId)
    },
    search: function() {
      if (this.typename === 'all') {
        this.is_checked = 0
      } else {
        this.is_checked = 1
      }
      this.handleSearch()
    },
    handleSearch() {
      let com = ''
      this.IsLoading = true
      // 如果有跳转flag存在则读取flag并且清除掉 (满足从首页过来的跳转)
      if (this.$store.state.trustListPageTarget) {
        this.typename = this.$store.state.trustListPageTarget
        console.log(this.typename)
        this.$store.dispatch('CLEAN_TRUST_LIST_PAGE_TARGET')
      }
      // 获取跳转flag方式2 （满足从调度申请单管理页面的跳转）
      const flag = window.localStorage.getItem('trustListFlag')
      if (flag) {
        this.typename = flag
      }
      console.log('flag', flag)
      window.localStorage.setItem('trustListFlag', '')
      // 判断选择的库存类型 all = 委托总库 self = 自己委托库
      if (this.typename === 'all') {
        com += '?isCustomerRelated=false'
      } else if (this.typename === 'self') {
        com += '?isCustomerRelated=true'
      }
      if (this.activename === 'rent_sales') {
        com += '&lotType=rent_sales'
      } else if (this.activename === 'rent') {
        com += '&lotType=rent'
      } else if (this.activename === 'sales') {
        com += '&lotType=sales'
      } else if (this.activename === 'managed') {
        com += '&expired=true'
      }
      let URL = 'CustomerDelegatedProductQuantity' + com
      const Services = o(URL)
      let filters = []
      if (this.Search.ProductModel) {
        filters.push(`ProductModelId eq ${this.Search.ProductModel}`)
      }
      if (this.Search.Region) {
        filters.push(`RegionId eq ${this.Search.Region}`)
      }
      // TODO 加入删选其他机型
      if (this.Search.ProductModule) {
        filters.push(`ProductModuleId eq ${this.Search.ProductModule}`)
      }
      console.log(this.Search.BrandName)
      if (this.Search.BrandName) {
        filters.push(`ProductBrandName eq '${this.Search.BrandName}'`)
      }
      if (this.Search.ProductCondition) {
        filters.push(`ConditionId eq ${this.Search.ProductCondition}`)
      }
      if (this.Search.Product) {
        filters.push(`contains(ProductName, '${this.Search.Product.replace(/(^\s*)|(\s*$)/g, '')}')
          or
          contains(ProductCode, '${this.Search.Product.replace(/(^\s*)|(\s*$)/g, '')}')
        `)
      }
      // 读取首页库存查询带过来的物料名称、编码【modifyby:zdx modifyon:2017-10-16】
      let pnames = this.$route.query.product
      if (pnames && pnames.length > 0) {
        let pnamearr = pnames.split(',')
        let _product = '('
        for (let i = 0; i < pnamearr.length; i++) {
          if (pnamearr[i].length > 0) {
            _product += `contains(ProductName,'${pnamearr[i]}')
              or
              contains(ProductCode, '${pnamearr[i]}')`
            if (i < pnamearr.length - 1) {
              _product += ' or '
            }
        //     filters.push(`contains(ProductName, '${pnamearr[i]}')
        //   or
        //   contains(ProductCode, '${pnamearr[i]}')
        // `)
          }
        }
        _product += ')'
        console.log(_product)
        filters.push(_product)
      }
      if (filters.length > 0) {
        Services.filter(filters.join(' and '))
      }
      Services.inlineCount()
      Services.skip((this.currentPage - 1) * this.pageSize)
      Services.top(this.pageSize)
      // Services.orderBy('OrderDate', 'desc')
      Services.get().then(({ data, inlinecount }) => {
        this.tableData = data
        this.total = inlinecount
        if (this.typename === 'all' && inlinecount === 0) {
          this.newboxshow = true
        } else {
          this.newboxshow = false
        }
        var a = []
        var b = []
        var c = []
        var d = []
        // var f = []
        a = JSON.parse(window.localStorage.getItem('purchasebox'))
        b = JSON.parse(window.localStorage.getItem('shipbox'))
        c = JSON.parse(window.localStorage.getItem('leaseapplybox'))
        d = JSON.parse(window.localStorage.getItem('managedbox'))
        // f = JSON.parse(window.localStorage.getItem('activebox'))
        if (a == null) {
          window.localStorage.setItem('purchasebox', JSON.stringify(this.purchasebox))
        } else {
          this.purchasebox = JSON.parse(window.localStorage.getItem('purchasebox'))
        }
        if (b == null) {
          window.localStorage.setItem('shipbox', JSON.stringify(this.shipbox))
        } else {
          this.shipbox = JSON.parse(window.localStorage.getItem('shipbox'))
        }
        if (c == null) {
          window.localStorage.setItem('leaseapplybox', JSON.stringify(this.leaseapplybox))
        } else {
          this.leaseapplybox = JSON.parse(window.localStorage.getItem('leaseapplybox'))
        }
        if (d == null) {
          window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
        } else {
          this.managedbox = JSON.parse(window.localStorage.getItem('managedbox'))
        }
        // if (f == null) {
        //   window.localStorage.setItem('activebox', JSON.stringify(this.activebox))
        // } else {
        //   this.activebox = JSON.parse(window.localStorage.getItem('activebox'))
        // }
        this.IsLoading = false
      }).fail((error) => {
        this.IsLoading = false
        this.$alert(error.message)
      })
    },
    // initDelegation: function() {
    //   const Delegation = o('DelegationActivationLot').expand('Lot,Warehouse,Region')
    //   Delegation.inlineCount()
    //   Delegation.skip((this.currentPage - 1) * this.pageSize)
    //   Delegation.top(this.pageSize)
    //   Delegation.get().then(({ data, inlinecount }) => {
    //     this.managedTimeData = data.data
    //     this.total = inlinecount
    //   }).fail((error) => {
    //     this.$alert(error.message)
    //   })
    // },
    initBrandNames: function() {
      const BrandName = o('ProductBrand')
      BrandName.get().then((data) => {
        // 按顺序遍历品牌排序名数组
        this.sorts.forEach(function(item) {
          // 遍历返回的品牌的集合，找到了遍历的品牌则插入到品牌集合中
          data.data.forEach(function(item2, index) {
            if (item2.Name === item) {
              this.BrandNames.push(item2)
              // 添加进集合后移除掉已经添加的品牌
              data.data.splice(index, 1)
            }
          }, this)
        }, this)
        // 把除'其他'品牌加进去
        // data.data.forEach(function(item, index) {
        //   if (!item.Name.indexOf('其他') > 0) {
        //     this.BrandNames.push(item)
        //     data.data.splice(index, 1)
        //   }
        // }, this)
        // // 最后加入其他品牌
        // data.data.forEach(function(item, index) {
        //   this.BrandNames.push(item)
        // }, this)
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    sortBrand: function() {
    },
    initProductModel: function(brandName) {
      this.ProductModels = []
      let ProductModel = o('ProductModel')
      if (brandName) {
        ProductModel.filter(`contains(Name, '${brandName}')`)
      }
      ProductModel.get().then((data) => {
        // 当有品牌名传入则进行联动排序
        if (brandName) {
          // 根据查询到的排序级别排序.从1开始,找到对应的级别的机型push集合中。遍历结束后push剩下的机型
          const count = data.data.length
          for (let i = 1; i <= count; i++) {
            // 找到对应的排序级别机型
            const insertItem = data.data.find((_) => _.Sort === i)
            // 如果没有该排序级别则不添加
            if (insertItem) {
              this.ProductModels.push(insertItem)
              // 获取到该机型在原数组中的下标，根据下标移除
              const removeIndex = data.data.findIndex(_ => _.Code === insertItem.Code)
              data.data.splice(removeIndex, 1)
            }
          }
          // 添加剩下的机型
          // data.data.forEach(function(item, index) {
          //   this.ProductModels.push(item)
          // }, this)
        } else {
          this.ProductModels = data.data
        }
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initProductModule: function() {
      let ProductModule = o('ProductModule')
      ProductModule.get().then((data) => {
        this.ProductModules = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    // TODO根据机型获取所有模块
    initProductModuleByModelId: function(modelId) {
      let ProductModule = o('Product')
      console.log(modelId)
      ProductModule.filter(`ModuleId eq ${modelId}`)
      ProductModule.get().then((data) => {
        console.log(data.data)
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initProductCondition: function() {
      const ProductCondition = o('ProductCondition')
      ProductCondition.get().then((data) => {
        this.ProductConditions = data.data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    initReion: function() {
      const Region = o('Region')
      Region.get().then(({ data, inlinecount }) => {
        this.Regions = data
      }).fail((error) => {
        this.$alert(error.message)
      })
    },
    handleTabClick({ name }) {
      this.activename = name
      this.handleSearch()
    },
    btnTabClick: function({ name }) {
      if (name === 'all') {
        this.activename = 'rent_sales'
        this.is_checked = 0
      } else {
        this.is_checked = 1
      }
      this.typename = name
      this.handleSearch()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.handleSearch()
    },
    handleChange(page) {
      this.currentPage = page
      this.handleSearch()
    },
  },
  components: {
    ListLayout,
  },
  created() {
    this.handleSearch()
    this.initReion()
    this.initBrandNames()
    this.initProductModel()
    this.initProductCondition()
    this.initProductModule()
  },
}
</script>

<style lang="less" scoped>
p.pull-left {
  padding-top: 10px;
}

.el-pagination {
  margin-top: 20px;
}

.form-input {
  width: 260px;
}

.list-layout .complex-table .sub-row-table .sub-body .text-center {
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

.main-content {
  .tab {
    .el-tabs__active-bar {
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.allweare {
  display: inline-block;
}

.newbox {
  .form-input {
    width: 100%;
  }
  .canadd {
    text-align: center;
    padding: 30px;
    color: red;
    font-size: 18px;
  }
}

.add-btn {
  font-size: 12px;
  color: #FFFFFF;
  background: #20a0ff;
  border-radius: 4px;
  float: right;
  margin-bottom: 20px;
  margin-left: 10px;
  border: none;
  span {
    color: #2283CA;
    font-size: 10px;
    width: 12px;
    height: 12px;
    background-color: #fff;
    margin-left: 5px;
    border-radius: 50%;
  }
}
.add-btn1 {
  font-size: 12px;
  color: #FFFFFF;
  background: #e88603;
  border-radius: 4px;
  float: right;
  margin-bottom: 20px;
  margin-left: 10px;
  border: none;
  span {
    color: #2283CA;
    font-size: 10px;
    width: 12px;
    height: 12px;
    background-color: #fff;
    margin-left: 5px;
    border-radius: 50%;
  }
}
.add-btn:hover,
.add-btn:focus {
  color: #FFFFFF;
  background: #2283CA;
}
.add-btn1:hover,
.add-btn1:focus {
  color: #FFFFFF;
  background: #eaaf22;
}
.newbox .el-form-item{margin-bottom: 0;}
.el-button--warning{background-color: #e88603;border-color: #e88603}
</style>



// WEBPACK FOOTER //
// TrustListPage.vue?3c65ca80